var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NameTag50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.016,92.03h-47.07c-4.971,0-9-4.029-9-9V13.999c0-2.209,1.791-4,4-4h53.368 c4.806,0,8.702,3.896,8.702,8.702v63.33C86.016,87.553,81.538,92.03,76.016,92.03z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M75.009,89.959H25.992c-4.971,0-9-4.029-9-9V14.983c0-4.418,3.582-8,8-8h50.017c4.971,0,9,4.029,9,9 v64.976C84.009,85.929,79.98,89.959,75.009,89.959z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9eeff",
    d: "M72.718,83.66h-46c-2.209,0-4-1.791-4-4V17.814c0-2.209,1.791-4,4-4h46c2.209,0,4,1.791,4,4V79.66 C76.718,81.87,74.927,83.66,72.718,83.66z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#70bfff",
    d: "M76.718,23.974h-54v-6.16c0-2.209,1.791-4,4-4h46c2.209,0,4,1.791,4,4V23.974z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#40396e",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M73.507,83.479H27.508c-2.209,0-4-1.791-4-4V17.466 c0-2.209,1.791-4,4-4h45.999c2.209,0,4,1.791,4,4v62.013C77.507,81.688,75.716,83.479,73.507,83.479z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#70bfff",
    d: "M64.486,61.997H35.505c-0.842,0-1.525-0.672-1.525-1.501s0.683-1.501,1.525-1.501h28.981 c0.842,0,1.525,0.672,1.525,1.501S65.328,61.997,64.486,61.997z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#70bfff",
    d: "M66.025,67.524c0,0.828-0.684,1.5-1.526,1.5H35.506c-0.842,0-1.526-0.672-1.526-1.5 s0.684-1.5,1.526-1.5h28.994C65.342,66.024,66.025,66.696,66.025,67.524z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#70bfff",
    d: "M54.442,75.968H35.514c-0.847,0-1.535-0.672-1.535-1.5s0.687-1.5,1.535-1.5h18.927 c0.847,0,1.535,0.672,1.535,1.5S55.289,75.968,54.442,75.968z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7a3",
    d: "M55.976,34.447c0,3.604-2.902,6.522-6.482,6.522c-3.584,0-6.486-2.918-6.486-6.522 c0-3.6,2.902-6.518,6.486-6.518C53.074,27.929,55.976,30.847,55.976,34.447z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#707cc0",
    d: "M62.469,53.996c-2.103-5.856-7.128-9.978-13-9.978c-5.869,0-10.893,4.126-12.996,9.978H62.469z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NameTag50);
export default __webpack_public_path__ + "static/media/icons8-name-tag-50.51b67f9f820573913f2f7f6bdf416723.svg";
export { ForwardRef as ReactComponent };